import { WithTranslationProps } from 'react-i18next/*';
import { BaseEntityPropsInitial, IBaseEntityProps } from '../BaseEntity/IBaseEntityProps';
import { InitialSearchHelperProps, ISearchHelperProps } from './IHelperProps';
import { SearchDTO } from './SearchDTO';

export interface ISearchProps extends IBaseEntityProps<SearchDTO, ISearchHelperProps<any>>, WithTranslationProps {
}

export const SearchPropsInitial: ISearchProps = { ...BaseEntityPropsInitial, DataDTO: { SearchString: ""}, DataHelper: InitialSearchHelperProps };